"use client";

import { usePathname } from "next/navigation";
import { LandingTopBar } from "@/components/public/LandingTopBar";
import { PublicBackground } from "@/components/public/PublicBackground";
import { Footer } from "@/components/public/Footer";
import { CookieConsent } from "@/components/public/CookieConsent";
import { GoogleAnalytics } from "@/components/public/GoogleAnalytics";

export function PublicLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const page = pathname?.split("/")[1] || "";
  const isHomepage = !pathname || pathname === "/";

  return (
    <>
      <GoogleAnalytics />
      <div className="flex flex-col min-h-screen relative">
        <PublicBackground page={page} />
        {/* TopBar spacer - hidden on homepage where header overlays the hero */}
        <div className={`flex-shrink-0 ${isHomepage ? 'h-0' : 'h-16'}`} />
        <LandingTopBar />
        <main className="relative z-10">{children}</main>
        <Footer />
        <CookieConsent />
      </div>
    </>
  );
}
